import React, { useState, useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const fmt = (n) => n.toLocaleString('pt-BR');

export const AnimatedCounter = ({ value, suffix = '', prefix = '', isInfinity = false, delay = 1100, duration = 2400 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (!inView || isInfinity) return;
    const target = parseFloat(value);
    const decimals = String(value).includes('.') ? 1 : 0;
    let raf, start;
    const tick = (ts) => {
      if (start === undefined) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const cur = target * eased;
      setCount(decimals ? Math.round(cur * 10) / 10 : Math.round(cur));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    const t = setTimeout(() => { raf = requestAnimationFrame(tick); }, delay);
    return () => { clearTimeout(t); if (raf) cancelAnimationFrame(raf); };
  }, [inView, value, isInfinity, delay, duration]);

  return (
    <span ref={ref}>
      {isInfinity ? (
        <motion.span initial={{ opacity: 0, scale: 0.5 }} animate={inView ? { opacity: 1, scale: 1 } : {}} transition={{ duration: 0.8, delay: 1.1, type: 'spring' }}>
          &infin;
        </motion.span>
      ) : (
        <>{prefix}{fmt(count)}{suffix}</>
      )}
    </span>
  );
};
